// extracted by mini-css-extract-plugin
export default {"sponsor-container":"sponsors_sponsor-container__ofJdt","sponsor-row":"sponsors_sponsor-row__9-tay","sponsor-item":"sponsors_sponsor-item__Uo3Gv","primary":"sponsors_primary__xilY1"};